document.addEventListener("DOMContentLoaded", function () {
  handleMcProductReviewsCarousel();
});

function handleMcProductReviewsCarousel() {
  const mcProductReviewsSwiperContainer = document.querySelector(
    ".mc-product-reviews__wrapper"
  );

  if (!mcProductReviewsSwiperContainer) {
    return;
  }

  const config = {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".mc-product-reviews__next",
      prevEl: ".mc-product-reviews__prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    breakpoints: {
      560: {
        slidesPerView: 2,
      },
      960: {
        slidesPerView: 3,
      },
    },
  };

  try {
    new Swiper(mcProductReviewsSwiperContainer, { ...config });
  } catch (error) {
    console.warn("Swiper initialization failed:", error);
  }
}
